<template>
  <div id="history" v-if="histroy.show">
    <div class="mask"></div>
    <div class="history_box">
      <div class="history_title">
        <label>历史记录</label>
        <a href="javascript:;" class="close_h" @click="hide">×</a>
      </div>
      <div class="history_content" v-if="histroy.text_answer">

        <div class="h_left">
          <div v-if="histroy.text_answer.length > 0">
            <div v-for="(item, index) in histroy.text_answer" :key="index">
              <a href="javascript:;" :key="index" v-if="item.answer != ''" :class="{ 'check': index == cur }"
                data-index="0" @click="changeHistroy(index)">{{ item.time }}</a>
            </div>
          </div>

        </div>
        <div class="h_right" v-if="histroy.text_answer">
          <div>
            <Editor :topic="topic" v-model="curAnswer" :showToolBar="false" :disable="true" />
          </div>

        </div>

      </div>
      <div class="history_btn">
        <a href="javascript:;" class="restore" @click="restore">恢复</a>
        <a href="javascript:;" class="cancel" @click="hide">取消</a>
      </div>
    </div>
  </div>
</template>
<script>
import Editor from "@/components/paper/editor2"
export default {
  name: "history2",
  components: { Editor },
  data () {
    return {
      cur: 0,
      histroy: {},
      curAnswer: ''
    }
  },
  props: ["data", "topic"],
  watch: {
    data: {
      immediate: true,
      handler (val) {
        this.histroy = JSON.parse(JSON.stringify(val));
        this.curAnswer = "";
        val.text_answer.map((item, index) => {
          if (item.answer != '') {
            this.cur = index;
            this.curAnswer = item.answer;
            // 滚动到追最后
            this.$nextTick(() => {
              const h_left = document.querySelector('.h_left');
              if (h_left) {
                h_left.scrollTop = h_left.scrollHeight;
              }
            })
          }
        });
      },
      deep: true
    }
  },
  created () {

  },
  methods: {
    //隐藏
    hide () {
      this.data.show = false
    },
    //恢复
    restore () {
      this.$emit("restore", this.data.text_answer[this.cur].answer);
      this.hide();
    },
    // 切换
    changeHistroy (index) {
      this.cur = index;
      this.histroy = JSON.parse(JSON.stringify(this.data));
      this.curAnswer = this.histroy.text_answer[index].answer;
    }
  }
}
</script>
<style lang="scss" scoped>
#history {
  position: relative;
  z-index: 999999999;
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.history_box {
  position: fixed;
  width: 1000px;
  top: 5%;
  left: 50%;
  margin-left: -500px;
  background: #ffffff;
  box-shadow: 0 0 2px #828790;
}

.history_title {
  background: #800000;
  color: #fff;
  padding: 10px;
}

.close_h {
  float: right;
  background: #e7661c;
  color: #fff;
  width: 20px;
  text-align: center;
  height: 20px;
  line-height: 20px;
}

.history_content {
  height: 500px;
  height: calc(100vh - 200px);
}

.history_content .h_left {
  float: left;
  width: 200px;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid #828790;
  border-bottom: 1px solid #828790;
}

.h_left a {
  padding: 10px 5px;
  display: block;
}

.h_left .check {
  background: #1d7ecc;
  color: #fff;
}

.history_content .h_right {
  overflow-y: auto;
  margin-left: 200px;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #c6cace;
}

.history_btn {
  text-align: center;
  width: 100%;
  border-top: 1px solid #828790;
}

.history_btn a {
  display: inline-block;
  background: #1d7ecc;
  color: #fff;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  margin: 5px 49px;
}
</style>